
// initial state
const state = {
  auth: {
    text: '',
  },
};

// getters
const getters = {
};

// actions
const actions = {
};

// mutations
const mutations = {
  setAuthError(state, playload) {
    state.auth.text = playload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/errors.js